import { systemEngineEnvironment } from "services/environment/systemEngine";

type SqlRoleName = {
  roleName: string;
};

export const fetchRoleNames = async (): Promise<string[]> => {
  const result = await systemEngineEnvironment.execute<SqlRoleName>(
    `
SELECT
  er.role_name
FROM
  information_schema.enabled_roles er
ORDER BY er.role_name
`
  );

  const [response] = result;
  return (response?.rows || []).map(r => r.roleName);
};
